import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchMenuComponent } from './search-menu.component';
import { TranslateModule } from '@xref/ngx';
import { CategoryIconModule } from '../category-icon/category-icon.module';
import { MatDividerModule } from '@angular/material/divider';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
  declarations: [SearchMenuComponent],
  imports: [
    CommonModule,
    TranslateModule,
    CategoryIconModule,
    MatDividerModule,
    FontAwesomeModule
  ],
  exports: [SearchMenuComponent]
})
export class SearchMenuModule {}
